import { grey } from "@mui/material/colors";
import { LIGHT_GREEN } from "styles/oneOffColor";

const styles = {
  text: {
    color: grey[700],
  },
  closeButton: {
    fontSize: 14,
    width: 25,
    height: 25,
    position: "absolute",
    top: 10,
    right: 10,
  },
  discount: {
    mt: 1,
    color: "green.main",
    fontSize: 12,
  },
  row: (lastRow?: boolean) => ({
    borderBottom: lastRow ? 0 : `1px solid ${grey[200]}`,
  }),
  cell: {
    px: 0.5,
    display: "flex",
    alignItems: "center",
    py: 2,
  },
  cellWithLeftAndRightBorder: (lastRow?: boolean) => ({
    borderLeft: `1px solid`,
    borderRight: `1px solid`,
    borderColor: "green.main",
    borderBottomLeftRadius: lastRow ? 14 : 0,
    borderBottomRightRadius: lastRow ? 14 : 0,
    borderBottom: lastRow ? `1px solid` : 0,
    px: 0.5,
    py: 2,
    display: "flex",
    alignItems: "center",
  }),
  attribute: {
    fontSize: 14,
  },
  planName: {
    color: "white",
  },
  card: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    borderRadius: 4,
    py: 1.5,
    px: 2,
    height: 150,
  },
  cardBorder: {
    border: "1px solid",
    borderColor: "green.main",
    p: 0.5,
    borderTopLeftRadius: 14,
    borderTopRightRadius: 14,
    borderBottom: 0,
  },
  chip: {
    width: "fit-content",
    fontSize: 11,
    borderRadius: 4,
    px: 2,
    py: 0.5,
    fontWeight: 600,
  },
  startAtText: {
    fontSize: 12,
    color: LIGHT_GREEN,
    opacity: 0.3,
  },
  priceText: {
    color: "white",
    fontSize: 16,
  },
};

export default styles;
